/* ============================================================
   QUICK VIEW MODAL — JS
   Apre il modal al click su [data-qv] usando i dati del card__json.
   ============================================================ */
(function(){
  var overlay = document.getElementById("qvOverlay");
  var modal   = document.getElementById("qvModal");
  if(!overlay) return;

  var imgEl    = document.getElementById("qvImg");
  var titleEl  = document.getElementById("qvTitle");
  var priceEl  = document.getElementById("qvPrice");
  var sizesEl  = document.getElementById("qvSizes");
  var colorsEl = document.getElementById("qvColors");
  var sizeWrap = document.getElementById("qvSizeWrap");
  var colorWrap= document.getElementById("qvColorWrap");
  var sizeNameEl  = document.getElementById("qvSizeName");
  var colorNameEl = document.getElementById("qvColorName");
  var atcBtn   = document.getElementById("qvAtc");
  var linkEl   = document.getElementById("qvLink");
  var detailEl = document.getElementById("qvDetailLink");
  var dotsEl   = document.getElementById("qvDots");
  var prevBtn  = document.getElementById("qvPrev");
  var nextBtn  = document.getElementById("qvNext");

  var state = { data: null, color: null, size: null, imgIdx: 0, images: [] };

  /* ---------- open ---------- */
  document.addEventListener("click", function(e){
    var btn = e.target.closest("[data-qv]");
    if(!btn) return;
    /* la card è dentro un link alla PDP: senza questo il click navigherebbe via */
    e.preventDefault();
    e.stopPropagation();
    var card = btn.closest("[data-product]");
    if(!card) return;
    var jsonEl = card.querySelector(".card__json");
    if(!jsonEl) return;
    try{
      var d = JSON.parse(jsonEl.textContent);
      openModal(d);
    } catch(err){ console.warn("QV parse error", err); }
  });

  function openModal(d){
    state.data  = d;
    state.color = null;
    state.size  = null;
    state.images = d.images && d.images.length ? d.images : [];
    state.imgIdx = 0;

    titleEl.textContent = d.title;
    linkEl.href = d.url || "#";
    detailEl.href = d.url || "#";
    detailEl.textContent = "Vedi tutti i dettagli →";

    updatePrice(d.price_f, d.has_compare ? d.compare_f : null, d.off);
    buildImages();
    buildColors(d);
    buildSizes(d, null);
    updateAtc();

    overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
    setTimeout(function(){ modal.querySelector(".qv-close") && modal.querySelector(".qv-close").focus(); }, 80);
  }

  /* ---------- close ---------- */
  function closeModal(){
    overlay.classList.remove("is-open");
    document.body.style.overflow = "";
  }
  document.getElementById("qvClose").addEventListener("click", closeModal);
  overlay.addEventListener("click", function(e){ if(e.target === overlay) closeModal(); });
  document.addEventListener("keydown", function(e){ if(e.key === "Escape") closeModal(); });

  /* ---------- images ---------- */
  function buildImages(){
    dotsEl.innerHTML = "";
    if(state.images.length <= 1){ prevBtn.classList.add("hidden"); nextBtn.classList.add("hidden"); }
    else{
      prevBtn.classList.remove("hidden"); nextBtn.classList.remove("hidden");
      state.images.forEach(function(_,i){
        var d = document.createElement("button");
        d.type = "button"; d.className = "qv-dot" + (i===0?" is-on":"");
        d.setAttribute("aria-label","Foto " + (i+1));
        d.dataset.i = i;
        dotsEl.appendChild(d);
      });
    }
    setImage(0);
  }
  function setImage(idx){
    if(!state.images.length) return;
    idx = Math.max(0, Math.min(idx, state.images.length-1));
    state.imgIdx = idx;
    imgEl.src = state.images[idx];
    prevBtn.classList.toggle("hidden", idx === 0);
    nextBtn.classList.toggle("hidden", idx === state.images.length-1);
    dotsEl.querySelectorAll(".qv-dot").forEach(function(d){ d.classList.toggle("is-on", parseInt(d.dataset.i)===idx); });
  }
  prevBtn.addEventListener("click", function(){ setImage(state.imgIdx-1); });
  nextBtn.addEventListener("click", function(){ setImage(state.imgIdx+1); });
  dotsEl.addEventListener("click", function(e){
    var d = e.target.closest(".qv-dot"); if(d) setImage(parseInt(d.dataset.i));
  });

  /* sfoglia col dito anche qui, non solo con le frecce */
  function upsilSwipe(area, img, o) {
    /* Sfoglia col dito: la foto segue il dito e la successiva entra di lato.
       o.count() quante foto, o.index() quale ora, o.src(i) indirizzo, o.go(i) cambio vero */
    var ghost = document.createElement("img");
    ghost.className = "swipe-ghost"; ghost.alt = ""; ghost.setAttribute("aria-hidden", "true");
    area.insertBefore(ghost, img.nextSibling);
    area.style.touchAction = "pan-y";
    var x0 = null, y0 = 0, t0 = 0, W = 0, dir = 0, lock = null, busy = false, last = 0;
    var EASE = "transform .26s cubic-bezier(.22,.7,.3,1)";
    function put(el, x, anim) { el.style.transition = anim ? EASE : "none"; el.style.transform = "translate3d(" + x + "px,0,0)"; }
    function reset() {
      img.style.transition = "none"; img.style.transform = "";
      ghost.style.display = "none"; ghost.style.transform = "";
      void img.offsetWidth; img.style.transition = ""; busy = false;
    }
    function target() { return o.index() + dir; }
    function has() { var t = target(); return dir !== 0 && t >= 0 && t < o.count(); }
    function preload(i) { if (i >= 0 && i < o.count()) { var p = new Image(); p.src = o.src(i); } }
    area.addEventListener("touchstart", function (e) {
      if (o.start) o.start();
      if (busy || e.touches.length !== 1 || o.count() < 2) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; t0 = Date.now();
      W = area.clientWidth; lock = null; dir = 0; last = 0;
      preload(o.index() + 1); preload(o.index() - 1);
    }, { passive: true });
    area.addEventListener("touchmove", function (e) {
      if (x0 === null) return;
      var dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
      if (lock === null) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        lock = Math.abs(dx) > Math.abs(dy) * 1.2 ? "x" : "y";
      }
      if (lock !== "x") return;
      if (o.drag) o.drag();
      var d = dx < 0 ? 1 : -1;
      if (d !== dir) {
        dir = d;
        if (has()) { ghost.src = o.src(target()); ghost.style.display = "block"; }
        else ghost.style.display = "none";
      }
      last = has() ? dx : dx * 0.25;          /* in fondo alla galleria la foto fa resistenza */
      put(img, last, false);
      if (has()) put(ghost, last + dir * W, false);
    }, { passive: true });
    function end() {
      if (x0 === null) return;
      x0 = null;
      if (lock !== "x") return;
      var quick = Date.now() - t0 < 260 && Math.abs(last) > 24;
      var go = has() && (quick || Math.abs(last) > Math.min(70, W * 0.2));
      var t = target();
      busy = true;
      put(img, go ? -dir * W : 0, true);
      if (has()) put(ghost, go ? 0 : dir * W, true);
      setTimeout(function () {
        if (!go) { reset(); return; }
        o.go(t);                               /* la foto nuova si carica sotto quella entrata */
        var done = false, fin = function () { if (!done) { done = true; reset(); } };
        if (img.decode) img.decode().then(fin, fin); else img.addEventListener("load", fin, { once: true });
        setTimeout(fin, 1200);
      }, 270);
    }
    area.addEventListener("touchend", end, { passive: true });
    area.addEventListener("touchcancel", end, { passive: true });
  }
  upsilSwipe(imgEl.parentNode, imgEl, {
    count: function(){ return state.images.length; },
    index: function(){ return state.imgIdx || 0; },
    src:   function(i){ return state.images[i]; },
    go:    function(i){ setImage(i); }
  });

  /* ---------- colors ---------- */
  function buildColors(d){
    var colors = [];
    d.variants.forEach(function(v){
      if(v.color && !colors.find(function(c){ return c.name===v.color; }))
        colors.push({ name: v.color });
    });
    if(!colors.length){ colorWrap.style.display="none"; return; }
    colorWrap.style.display = "";
    colorsEl.innerHTML = "";
    colors.forEach(function(c){
      var btn = document.createElement("button");
      btn.type="button"; btn.className="qv-circle";
      btn.dataset.color = c.name;
      btn.title = c.name;
      /* Stesso campione della scheda prodotto: immagine del campione nativo
         Shopify se c'e', altrimenti PNG nostro, altrimenti tinta piatta.
         Prima qui finiva la foto della variante rimpicciolita, che in un
         cerchietto da 40px diventa una macchia. */
      var ci = d.color_imgs && d.color_imgs[c.name];
      var i = document.createElement("i");
      if(ci && ci.sw){ i.style.cssText = ci.sw; }
      else { i.style.background = colorHex(c.name); }
      btn.appendChild(i);
      colorsEl.appendChild(btn);
    });
    /* auto-select first color */
    var first = colorsEl.querySelector(".qv-circle");
    if(first){ first.classList.add("is-on"); state.color = first.dataset.color; colorNameEl.textContent = state.color; }
  }

  colorsEl.addEventListener("click", function(e){
    var b = e.target.closest(".qv-circle"); if(!b) return;
    colorsEl.querySelectorAll(".qv-circle").forEach(function(x){ x.classList.remove("is-on"); });
    b.classList.add("is-on");
    state.color = b.dataset.color;
    colorNameEl.textContent = state.color;
    /* switch main image if available */
    var ci = state.data && state.data.color_imgs && state.data.color_imgs[state.color];
    if(ci && ci.img){ state.images = [ci.img]; buildImages(); }
    buildSizes(state.data, state.color);
    updateAtc();
  });

  /* ---------- sizes ---------- */
  function buildSizes(d, color){
    var seen = {}, out = [];
    d.variants.forEach(function(v){
      if(!v.size) return;
      var match = !color || v.color === color;
      if(!(v.size in seen)){ seen[v.size]=false; out.push(v.size); }
      if(match && v.available) seen[v.size]=true;
    });
    if(!out.length){ sizeWrap.style.display="none"; return; }
    sizeWrap.style.display = "";
    sizesEl.innerHTML = "";
    out.forEach(function(s){
      var btn = document.createElement("button");
      btn.type="button"; btn.className="qv-chip";
      btn.dataset.size = s; btn.textContent = s;
      if(!seen[s]) btn.disabled = true;
      sizesEl.appendChild(btn);
    });
    /* deselect size if no longer available */
    if(state.size){
      var still = sizesEl.querySelector("[data-size='"+state.size+"']");
      if(still && !still.disabled){ still.classList.add("is-on"); sizeNameEl.textContent = state.size; }
      else{ state.size = null; sizeNameEl.textContent = "—"; }
    }
    updateAtc();
  }

  sizesEl.addEventListener("click", function(e){
    var b = e.target.closest(".qv-chip"); if(!b || b.disabled) return;
    sizesEl.querySelectorAll(".qv-chip").forEach(function(x){ x.classList.remove("is-on"); });
    b.classList.add("is-on");
    state.size = b.dataset.size;
    sizeNameEl.textContent = state.size;
    updateAtc();
  });

  /* ---------- ATC ---------- */
  function findVariant(){
    var d = state.data; if(!d) return null;
    return d.variants.find(function(v){
      return (!state.color || v.color===state.color) && (!state.size || v.size===state.size) && v.available;
    }) || d.variants.find(function(v){
      return (!state.color || v.color===state.color) && (!state.size || v.size===state.size);
    });
  }
  function updateAtc(){
    var v = findVariant();
    if(v){
      atcBtn.setAttribute("data-variant-id", v.id);
      atcBtn.setAttribute("data-title", state.data ? state.data.title : "");
      var needsSize = sizeWrap.style.display !== "none" && !state.size;
      atcBtn.disabled = needsSize || !v.available;
      atcBtn.textContent = needsSize ? "Seleziona la taglia" : (v.available ? "AGGIUNGI AL CARRELLO" : "ESAURITO");
      updatePrice(v.price_f || (state.data && state.data.price_f), state.data && state.data.has_compare ? state.data.compare_f : null, state.data && state.data.off);
    } else {
      atcBtn.removeAttribute("data-variant-id"); atcBtn.disabled = true;
      atcBtn.textContent = "Non disponibile";
    }
  }
  function updatePrice(now, compare, off){
    var html = '<span class="now tnum">'+(now||"")+"</span>";
    if(compare) html += ' <span class="was tnum">'+compare+"</span>";
    if(off && off > 0) html += ' <span class="off">-'+off+"%</span>";
    priceEl.innerHTML = html;
  }

  /* close modal after ATC success */
  document.addEventListener("click", function(e){
    if(e.target.closest("#qvAtc") && e.target.closest("#qvAtc").dataset.variantId){
      setTimeout(closeModal, 600);
    }
  });

  /* ---- basic color hex fallback ---- */
  function colorHex(n){
    n = n.toLowerCase();
    var m = {
      nero:"#1b1814",bianco:"#f3efe9",grigio:"#8b8377","grigio scuro":"#4b4742",
      oro:"#c89a78",rosato:"#c89a78",rosso:"#9c4a44","verde militare":"#54604f",
      verde:"#5a6450",blu:"#4a5a78",turchese:"#3f7e7e",fucsia:"#b5588a",
      "rosa chiaro":"#e6b8be",rosa:"#e6b8be","viola chiaro":"#b3a6c8",viola:"#6a5a86",
      giallo:"#d8c06a",arancione:"#c08050",pesca:"#e7b58c",sabbia:"#c9b89c",
      carne:"#e3c4a8",marrone:"#7a5a48"
    };
    for(var k in m){ if(n.includes(k)) return m[k]; }
    return "#c9b89c";
  }
})();
